module.exports = __webpack_public_path__ + "img/logo-footer.3662a1ce.svg";